export const patientADT = {
  error_admit:
    "Sorry, there was an error while trying to admit the patient. Please try again or contact your organization's IT support staff.",
  error_transfer:
    "Sorry, there was an error while trying to transfer the patient. Please try again or contact your organization's IT support staff.",
  error_discharge:
    "Sorry, there was an error while trying to discharge the patient. Please try again or contact your organization's IT support staff.",
  sucess: "Patient ADT created successfully"
};
